import React from "react";
import { Link } from "react-router-dom";
import { Truck, Star, Shield, MapPin } from "lucide-react";

// REMINDER: remplacez GOOGLE_BUSINESS_URL par votre lien Google Business Profile réel
// (ex: https://g.page/r/VOTRE_PLACE_ID/review ou https://www.google.com/maps/place/...)
export const GOOGLE_BUSINESS_URL = "https://www.google.com/search?q=DepannRoute";

export default function Footer({ stats = null }) {
  return (
    <footer className="border-t border-slate-200 bg-white" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14 grid md:grid-cols-2 lg:grid-cols-4 gap-10">
        <div>
          <Link to="/" className="flex items-center gap-2">
            <span className="flex h-9 w-9 items-center justify-center bg-orange-600 text-white rounded-md">
              <Truck className="h-5 w-5" />
            </span>
            <span className="font-display font-extrabold text-lg tracking-tight text-slate-900">
              Depann<span className="text-orange-600">Route</span>
            </span>
          </Link>
          <p className="mt-3 text-sm text-slate-600 leading-relaxed max-w-xs">
            La marketplace opérationnelle du dépannage automobile. Matching aller/retour unique en
            France, Belgique, Espagne et Allemagne.
          </p>
          <div className="mt-4 flex items-center gap-3 text-xs text-slate-500">
            <MapPin className="h-3.5 w-3.5 text-orange-600" /> FR · BE · ES · DE
          </div>
          {stats && stats.rating_count > 0 && (
            <div className="mt-4 inline-flex items-center gap-2 rounded-md border border-amber-200 bg-amber-50 px-3 py-2">
              <Star className="h-4 w-4 fill-amber-500 text-amber-500" />
              <span className="text-sm font-semibold text-slate-900">{stats.rating_avg}/5</span>
              <span className="text-xs text-slate-600">· {stats.rating_count} avis</span>
            </div>
          )}
        </div>

        <div>
          <div className="text-[10px] font-bold uppercase tracking-[0.2em] text-slate-500">Plateforme</div>
          <ul className="mt-4 space-y-2 text-sm">
            <li><Link to="/register?role=client" className="text-slate-700 hover:text-orange-600">Publier une demande</Link></li>
            <li><Link to="/register?role=pro" className="text-slate-700 hover:text-orange-600">Devenir dépanneur</Link></li>
            <li><Link to="/avis" className="text-slate-700 hover:text-orange-600">Avis clients &amp; pros</Link></li>
            <li><Link to="/login" className="text-slate-700 hover:text-orange-600">Connexion</Link></li>
          </ul>
        </div>

        <div>
          <div className="text-[10px] font-bold uppercase tracking-[0.2em] text-slate-500">Légal</div>
          <ul className="mt-4 space-y-2 text-sm">
            <li><Link to="/mentions-legales" className="text-slate-700 hover:text-orange-600">Mentions légales</Link></li>
            <li><Link to="/cgu" className="text-slate-700 hover:text-orange-600">Conditions d'utilisation (CGU)</Link></li>
            <li><Link to="/cgv" className="text-slate-700 hover:text-orange-600">Conditions de vente (CGV)</Link></li>
            <li><Link to="/confidentialite" className="text-slate-700 hover:text-orange-600">Confidentialité &amp; RGPD</Link></li>
            <li><Link to="/cookies" className="text-slate-700 hover:text-orange-600">Politique cookies</Link></li>
          </ul>
        </div>

        <div>
          <div className="text-[10px] font-bold uppercase tracking-[0.2em] text-slate-500">Confiance</div>
          <a
            href={GOOGLE_BUSINESS_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="google-business-link"
            className="mt-4 flex items-center gap-3 p-3 border border-slate-200 rounded-md hover:border-orange-600 transition-colors"
          >
            <svg className="h-8 w-8" viewBox="0 0 48 48" aria-hidden="true">
              <path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"/>
              <path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"/>
              <path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"/>
              <path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"/>
            </svg>
            <div className="flex-1 min-w-0">
              <div className="text-[10px] uppercase tracking-widest font-bold text-slate-500">Avis Google</div>
              <div className="text-sm font-display font-bold text-slate-900 truncate">Voir notre page Google</div>
            </div>
          </a>
          <div className="mt-3 inline-flex items-center gap-1.5 text-xs text-slate-500">
            <Shield className="h-3.5 w-3.5 text-emerald-600" /> Paiement sécurisé Stripe
          </div>
        </div>
      </div>

      <div className="border-t border-slate-200 py-5 px-4 sm:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto flex flex-col sm:flex-row justify-between items-center gap-3 text-xs text-slate-500">
          <div>© {new Date().getFullYear()} DepannRoute · Plateforme opérationnelle · Commission 10%</div>
          <div className="flex items-center gap-4">
            <span>FR · BE · ES · DE</span>
            <span>·</span>
            <a href={GOOGLE_BUSINESS_URL} target="_blank" rel="noopener noreferrer" className="hover:text-orange-600">Google Business</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
